module.exports = __webpack_public_path__ + "img/C04-2-CasaBlanca.c79959af.png";